export default {
  title: {
    en: 'Your order',
  },
  shipping: {
    en: 'Will ship within 5 to 7 business days',
  },
  perfumeCaseText: {
    en: 'Will ship with your next month\'s subscription order',
  },
}
